import { IStyleFunctionOrObject } from "@fluentui/react";
import { CountryProfileStyleProps, CountryProfileStyles } from "./CountryProfile.types";

export const getStyles: IStyleFunctionOrObject<CountryProfileStyleProps, CountryProfileStyles> = (
  props: CountryProfileStyleProps
) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { theme } = props;
  return {
    root: {},
  };
};
